import { useEffect } from 'react';
import { GROWTH_CALCULATORS } from 'spw-constants';
import { setCurrentFloor } from 'spw-redux/modules/projects/actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  currentFloor,
  selectCurrentBuilding,
} from 'spw-redux/modules/projects/selectors';
import { selectCurrentScenario } from 'spw-redux/modules/calculators/selectors';
import { useLocation } from 'react-router-v5';

export const useScenarioFloor = () => {
  const floor = useSelector(currentFloor);
  const building = useSelector(selectCurrentBuilding);
  const scenario = useSelector(selectCurrentScenario);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !floor &&
      [
        GROWTH_CALCULATORS.floorHeadcountSeatcount,
        GROWTH_CALCULATORS.floorUsf,
      ].includes(scenario?.calculatorType)
    ) {
      const scenarioFloor = building.floors.find(
        (buildingFloor) => buildingFloor.id === scenario.floorId
      );
      dispatch(setCurrentFloor(scenarioFloor));
    }
  }, [dispatch, location, building?.floors, scenario, floor]);
};
